import shangtang from '@/page/shangtang/index'
import downMylink from '@/page/shangtang/downMylink'
import list from '@/page/shangtang/list'
import detail from '@/page/shangtang/detail'
export default [
  {
    path: '/shangtang',
    component: shangtang,
    meta: { title: '商汤大屏照片' }
  }, {
    path: '/downMylink/:have',
    component: downMylink,
    meta: { title: '商汤大屏照片' }
  }, {
    path: '/shangtang/list',
    component: list,
    meta: { title: '商汤大屏照片' }
  }, {
    path: '/shangtang/detail/:new',
    component: detail,
    meta: { title: '商汤大屏照片' }
  }]


// WEBPACK FOOTER //
// ./src/router/shangtang/index.js